import * as Yup from 'yup';
import {
  EDU_BUDGET_TITLE_MAX,
  EDU_BUDGET_DESCRIPTION_MAX,
  EDU_BUDGET_LINK_MAX,
  TEXT_FIELD_REGEX,
  TEXT_FIELD_MESSAGE,
} from 'constants/fieldLimits';

const greaterThanZeroRegExp = /^[1-9][0-9]*(\.[0-9]+)?$/;

const eduBudgetValidationSchema = Yup.object().shape({
  type: Yup.string().nullable().required('Type is required'),
  title: Yup.string()
    .nullable()
    .required('Title is required')
    .max(EDU_BUDGET_TITLE_MAX, `Title must be ${EDU_BUDGET_TITLE_MAX} characters or less`)
    .matches(TEXT_FIELD_REGEX, TEXT_FIELD_MESSAGE),
  description: Yup.string()
    .nullable()
    .required('Description is required')
    .max(
      EDU_BUDGET_DESCRIPTION_MAX,
      `Description must be ${EDU_BUDGET_DESCRIPTION_MAX} characters or less`,
    )
    .matches(TEXT_FIELD_REGEX, TEXT_FIELD_MESSAGE),
  totalAmount: Yup.string()
    .nullable()
    .matches(greaterThanZeroRegExp, 'The amount should be greater than 0')
    .required('Preliminary amount is required'),
  link: Yup.string()
    .nullable()
    .max(EDU_BUDGET_LINK_MAX, `Link must be ${EDU_BUDGET_LINK_MAX} characters or less`)
    .matches(
      // eslint-disable-next-line no-useless-escape
      /^https?:\/\/(www\.)?[a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/=]*)$/,
      'Please enter a valid link starting with http:// or https://',
    )
    .required('Link is required'),
  startDate: Yup.date()
    .nullable()
    .when('type', {
      is: type => type === 'Conference' || type === 'Workshop',
      then: schema => schema.required('Start date is required'),
    }),
  endDate: Yup.date()
    .nullable()
    .when('type', {
      is: type => type === 'Conference' || type === 'Workshop',
      then: schema => schema.required('End date is required'),
    }),
});

export default eduBudgetValidationSchema;
